import { Injectable } from '@angular/core';
import { ClientModels } from 'models/client.models';
import { BehaviorSubject, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { PolicyModels } from '../../../../models/policy.models';
import { ClientService } from './client.service';
import { ILogger } from './logger/ilogger';
import { LoggerService } from './logger/logger.service';

@Injectable({
  providedIn: 'root',
})
export class ClientDetailsService {
  private policySubject = new BehaviorSubject<PolicyModels.PolicyRecap | null>(
    null,
  );
  private clientSubject = new BehaviorSubject<ClientModels.Client | null>(null);
  private updateRequestsSubject = new Subject();
  private updateReceiptsSubject = new Subject();

  public currentPolicy$ = this.policySubject.asObservable();
  public currentClient$ = this.clientSubject.asObservable();
  public updateReceipts$ = this.updateReceiptsSubject.asObservable();

  public updateRequests$ = this.updateRequestsSubject.asObservable();

  public get currentClient() {
    return this.clientSubject.value;
  }
  public get currentPolicy() {
    return this.policySubject.value;
  }

  private logger: ILogger;

  constructor(
    loggerService: LoggerService,
    public clientService: ClientService,
  ) {
    this.logger = loggerService.getLogger('Client Details');
  }

  public setPolicyRecap(policy: PolicyModels.PolicyRecap) {
    this.logger.log('new policy', policy);
    this.policySubject.next(policy);
  }

  public setClient(client: ClientModels.Client) {
    this.logger.log('new clientDetails', client);
    this.clientSubject.next(client);
  }

  public clear() {
    this.clientSubject.next(null);
    this.policySubject.next(null);
  }

  public refreshPolicy(update?: Partial<PolicyModels.PolicyRecap>) {
    let updatedPolicy: PolicyModels.PolicyRecap | null = this.currentPolicy;
    if (update) {
      updatedPolicy = Object.assign(updatedPolicy!, update);
    }

    this.setPolicyRecap(updatedPolicy!);
  }

  public updateClientById(clientId: number) {
    return this.clientService.getClient(clientId).pipe(
      map((client) => {
        this.setClient(client);
        this.setPolicyRecap(
          this.getPolicyById(client, client.policies[0].value.id),
        );
      }),
    );
  }

  public updateReceipts() {
    this.updateReceiptsSubject.next(null);
  }

  public updateRequests() {
    this.updateRequestsSubject.next(null);
  }

  private getPolicyById(
    client: ClientModels.Client,
    policyId: number,
  ): PolicyModels.PolicyRecap {
    let index = 0;
    if (policyId) {
      const findIdx = client.policies.findIndex((p) => p.value.id === policyId);
      index = findIdx !== -1 ? findIdx : 0;
    }

    return client.policies[index].value;
  }
}
